import { Create, View, BankTransfer, OldBill } from "../Components/index.js";

export default [
    {
        path: "/voucher/fd/journal/create",
        component: Create,
        name: "voucher.fd.journal.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/fd/old-bill/create",
        component: OldBill,
        name: "voucher.fd.old.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/fd/journal/bank-transfer",
        component: BankTransfer,
        name: "voucher.fd.journal.transfer",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/fd/journal/:id/view",
        component: View,
        name: "voucher.fd.journal.view",
        meta: {
            requiresAuth: true,
        },
    },
];
